<div class="shell-container">
  <div class="shell-header">
    <div class="logo-container">
      <img src="assets/img/DatexWht_Logo.svg">
    </div>
    <div id="title">
      <span class="appname"></span>
    </div>
    <div class="custom-header">
      <div class="menu">
        <button [matMenuTriggerFor]="menu"
                class="shell-button user-account">
          <app-management-user-tile *ngIf="userTile"
                                    [tile]="userTile"
                                    [tileSize]="userTileSize"></app-management-user-tile>
          <div class="user-email">{{ account?.username }}</div>
          <i class="icon icon-ic_fluent_chevron_down_20_regular user-chevron"></i>
        </button>
        <mat-menu #menu="matMenu"
                  class="options-menu">
          <span mat-menu-item>
            {{account?.name}}
          </span>
          <button mat-menu-item
                  (click)="onLogoutClicked()">
            <i class="icon icon-ic_fluent_sign_out_20_regular"></i>
            <span>Sign out</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
  <div class="shell-body">
    <div class="shell-content">
      <div class="application-common-container">
        <div class="nav-tabs-bar">
          <a class="nav-tab"
             *ngIf="hasManagementAccess"
             [routerLink]="['/management']">
            <span class="nav-tab-icon">
              <img src="managerfavicon.svg" />
            </span>
            <span class="nav-tab-label">Manager</span>
          </a>
          <div class="nav-search"
               *ngIf="applications?.length > 0">
            <input type="text"
                   class="datex-textbox search-input"
                   placeholder="Search for applications..."
                   [(ngModel)]="searchTerm">
            <button class="datex-button search-button"
                    (click)="onSearch()">
              <i class="icon icon-ic_fluent_search_20_regular"></i>
              Search
            </button>
          </div>
        </div>
        <div class="greeting-section">
          <h1 class="greeting-text">{{greeting}}</h1>
          <p class="current-date">{{currentDate}}</p>
        </div>

        <ng-container *ngIf="!loading; else loadingData">
          <div class="applications-section"
               *ngIf="applications?.length > 0; else emptyState">
            <h2 class="section-title">Applications</h2>
            <div class="cards-container">
              <div class="application-card"
                   *ngFor="let app of filteredApplications">
                <div class="card-header">
                  <span class="app-logo"><img src="{{app.logo}}" /></span>
                  <span class="environment-badge">{{app.environment}}</span>
                  <span class="app-name">{{app.name}}</span>
                </div>
                <p class="app-version">Version: {{app.version}}</p>
                <p class="app-description">{{app.description}}</p>
                <button class="datex-button launch-button"
                        (click)="onClick(app)">
                  Launch
                </button>
              </div>
            </div>
          </div>

          <ng-template #emptyState>
            <div class="empty-state">
              <i class="icon icon-ic_fluent_apps_20_regular empty-state-icon"></i>
              <h2 class="empty-state-title">No Applications Available</h2>
              <p class="empty-state-message">There are no applications assigned to your account at this time.</p>
            </div>
          </ng-template>
        </ng-container>

        <ng-template #loadingData>
          <div class="loading-container">
            <mat-spinner></mat-spinner>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>